import { LoginForm, LoginGraphics, LoginHeader } from "./components";

export default function AdminLogin() {
  return (
    <div className="min-h-screen w-full flex flex-col lg:flex-row bg-gradient-to-br from-amber-100 via-fuchsia-50 to-purple-200 dark:from-[#261705] dark:via-[#1a0f2e] dark:to-[#0a071f] overflow-hidden relative">
      {/* Base Background Image with reduced opacity and blend mode to match theme */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none opacity-30 dark:opacity-20 mix-blend-multiply dark:mix-blend-screen"
        style={{ backgroundImage: "url('/bg.png')" }}
      />

      {/* Theme Color Gradient Overlay to enrich colors further */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-500/20 via-fuchsia-600/20 to-purple-800/30 pointer-events-none" />

      {/* Decorative gradient orbs for immersive brand experience */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-amber-400/30 dark:bg-amber-500/10 rounded-full blur-[100px] pointer-events-none -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[800px] h-[800px] bg-purple-500/30 dark:bg-purple-600/10 rounded-full blur-[120px] pointer-events-none translate-x-1/3 translate-y-1/3" />

      {/* Left Side: Graphics and Branding (Hidden on mobile, visible on lg screens) */}
      {/* <div className="hidden lg:flex flex-1 relative z-10 p-8 xl:p-16">
        <LoginGraphics />
      </div> */}

      {/* Right Side: Login Form */}
      <div className="flex-1 flex flex-col relative z-10 w-full max-w-2xl mx-auto lg:max-w-none">
        {/* Top Header (Lang & Theme) */}
        <div className="w-full flex justify-end p-6 xl:p-8">
          <LoginHeader />
        </div>

        {/* Center Form Content */}
        <div className="flex flex-col justify-center items-center p-6 sm:p-12">
          <div className="w-full max-w-[480px]">
            <LoginForm />
          </div>
        </div>

        {/* Footer info */}
        {/* <div className="w-full p-6 xl:p-8 mt-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500 dark:text-slate-400">
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary transition-colors">
              Terms of Service
            </a>
            <div className="hidden sm:flex items-center gap-4 border-l border-slate-300 dark:border-slate-700 pl-4">
              <a
                href="mailto:support@drcsystems.com"
                className="hover:text-primary transition-colors"
              >
                support@drcsystems.com
              </a>
              <span>+91 98765 43210</span>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <span className="hidden sm:inline">v2.4.0 (Build 8492)</span>
            <div className="flex items-center gap-2 bg-white/60 dark:bg-slate-900/60 backdrop-blur-md px-3 py-1.5 rounded-full border border-slate-200 dark:border-slate-800 shadow-sm font-medium">
              <span className="flex h-2 w-2 rounded-full bg-emerald-500"></span>
              Production
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
